import React, { useState, useEffect } from 'react'
import '../../../../containers/Expressway/expressway.scss'
import ToggleSwitch from '../ToggleSwitch'
import { FETCH_EXPRESSWAY_DETAILS_URL, UPDATE_PREFILL_STATUS } from '../../../../constants/api_endpoints'
import { apiGetHelper, apiPostHelper, getTravellerObj } from '../../../../utils'
import PrimaryTravellerDetails from './PrimaryTravellerDetails'

const PrimaryTraveller = () => {
  const [switchVal, setSwitchVal] = useState(false)
  const [traveller, setTraveller] = useState({ title: '', fName: '', lName: '', mNo: '' })
  const [originalTraveller, setOriginalTraveller] = useState({ title: '', fName: '', lName: '', mNo: '' })
  useEffect(() => {
    getPtravellerInfo()
  }, [])

  const getTravellerData = () => {
    const response = apiGetHelper(
      `${FETCH_EXPRESSWAY_DETAILS_URL}?travellers=true`,
      true,
      {},
      { accept: 'text/json' }
    )
    return response
  }

  async function getPtravellerInfo() {
    const res = await getTravellerData()
    const travellerObj = getTravellerObj(res)
    if (travellerObj.prefill && travellerObj.prefill === 'Y') {
      setSwitchVal(true)
    } else {
      setSwitchVal(false)
    }
    setTraveller(travellerObj)
    setOriginalTraveller(travellerObj)
  }

  const makeTravellerPrefillStatusReq = (val = 'N') => {
    const response = apiPostHelper(
      `${UPDATE_PREFILL_STATUS}?travellers=true`,
      {
        other_details: [{
          id: originalTraveller.prefillId,
          category: 'ExpressCheckout',
          name: 'PrefillTravellerInfo',
          value: val
        }]
      },
      false,
      {},
      { accept: 'text/json' }
    )
    return response
  }

  async function updateTravellerPrefillStatus(val = false) {
    const value = val ? 'Y' : 'N'
    await makeTravellerPrefillStatusReq(value)
  }

  return (
    <div className="w-630 mt-3 apr-15 apl-15 apt-15 apb-15">
      <h2 className="mb-5 grey-5 fw-400 fs-20">Primary Traveller</h2>
      <span className="pTravellerLabel ml-6 fs-12 mr-3">Pre-fill traveller info</span>
      <ToggleSwitch name="newsletter" switchVal={switchVal} setSwitchVal={setSwitchVal} updateStatus={updateTravellerPrefillStatus} />
      <Choose>
        <When condition={switchVal}>
          <>
            <div className="pTravellerLabelSubtext">Turn this off if you book for others mostly.</div>
            <PrimaryTravellerDetails
              traveller={traveller}
              setTraveller={setTraveller}
              originalTraveller={originalTraveller}
            />
          </>
        </When>
        <Otherwise>
          <div className="pTravellerLabelSubtext">Turn this on if you frequently book for the same person.</div>
        </Otherwise>
      </Choose>
    </div>
  )
}

export default PrimaryTraveller
